import { useLang } from '@/i18n';
import EfVideo from '@elem/ui/ef-video';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useMediaDevice } from './hooks';
import styles from './index.module.scss';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.1161 1.09473C19.9786 0.720377 19.4491 0.720378 19.3116 1.09473L18.6306 2.94792C18.5873 3.06598 18.4942 3.15902 18.3762 3.20239L16.523 3.88331C16.1486 4.02085 16.1486 4.55031 16.523 4.68786L18.3762 5.36877C18.4942 5.41215 18.5873 5.50519 18.6306 5.62324L19.3116 7.47644C19.4491 7.85079 19.9786 7.85078 20.1161 7.47644L20.797 5.62324C20.8404 5.50519 20.9335 5.41215 21.0515 5.36877L22.9047 4.68786C23.2791 4.55031 23.2791 4.02085 22.9047 3.8833L21.0515 3.20239C20.9335 3.15902 20.8404 3.06598 20.797 2.94792L20.1161 1.09473ZM11.5455 2.80957C11.408 2.43522 10.8785 2.43522 10.741 2.80957L8.21754 9.67735C8.17416 9.7954 8.08112 9.88844 7.96307 9.93182L1.09522 12.4552C0.720865 12.5928 0.720865 13.1222 1.09522 13.2598L7.96307 15.7832C8.08112 15.8266 8.17416 15.9196 8.21754 16.0377L10.741 22.9055C10.8785 23.2798 11.408 23.2798 11.5455 22.9055L14.069 16.0377C14.1124 15.9196 14.2054 15.8266 14.3235 15.7832L21.1913 13.2598C21.5657 13.1222 21.5657 12.5928 21.1913 12.4552L14.3235 9.93182C14.2054 9.88844 14.1124 9.7954 14.069 9.67735L11.5455 2.80957Z"
            fill="#A07EF4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.1161 1.09473C19.9786 0.720377 19.4491 0.720378 19.3116 1.09473L18.6306 2.94792C18.5873 3.06598 18.4942 3.15902 18.3762 3.20239L16.523 3.88331C16.1486 4.02085 16.1486 4.55031 16.523 4.68786L18.3762 5.36877C18.4942 5.41215 18.5873 5.50519 18.6306 5.62324L19.3116 7.47644C19.4491 7.85079 19.9786 7.85078 20.1161 7.47644L20.797 5.62324C20.8404 5.50519 20.9335 5.41215 21.0515 5.36877L22.9047 4.68786C23.2791 4.55031 23.2791 4.02085 22.9047 3.8833L21.0515 3.20239C20.9335 3.15902 20.8404 3.06598 20.797 2.94792L20.1161 1.09473ZM11.5455 2.80957C11.408 2.43522 10.8785 2.43522 10.741 2.80957L8.21754 9.67735C8.17416 9.7954 8.08112 9.88844 7.96307 9.93182L1.09522 12.4552C0.720865 12.5928 0.720865 13.1222 1.09522 13.2598L7.96307 15.7832C8.08112 15.8266 8.17416 15.9196 8.21754 16.0377L10.741 22.9055C10.8785 23.2798 11.408 23.2798 11.5455 22.9055L14.069 16.0377C14.1124 15.9196 14.2054 15.8266 14.3235 15.7832L21.1913 13.2598C21.5657 13.1222 21.5657 12.5928 21.1913 12.4552L14.3235 9.93182C14.2054 9.88844 14.1124 9.7954 14.069 9.67735L11.5455 2.80957Z"
            fill="url(#paint0_linear_1296_226068)"
        />
        <defs>
            <linearGradient id="paint0_linear_1296_226068" x1="0.814454" y1="-10.3722" x2="56.4869" y2="64.9452" gradientUnits="userSpaceOnUse">
                <stop offset="0.0961147" stopColor="#76FFB2" />
                <stop offset="0.350137" stopColor="#2068CC" />
                <stop offset="1" stopColor="#3A8CFD" />
            </linearGradient>
        </defs>
    </svg>
);
const euPages = ['normal', 'ultra', 'ac'];

export default function TheComp(props: any) {
    const { pageType } = props;
    const { t } = useLang('theProduct.EcoAi');

    const { isPC, isDesktop, isPad, isH5 } = useMediaDevice();
    const [videoLoaded, setVideoLoaded] = useState(false);
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');
    // 标题动画
    useEffect(() => {
        if (pageType !== 'na') return;
        const box = document.querySelector('#AIDriven') as HTMLDivElement;
        const info = document.querySelector('#AIDriven .ai-driven-info') as HTMLDivElement;
        const show = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        info.classList.add('enter');
                    } else {
                        info.classList.remove('enter');
                    }
                });
            },
            {
                threshold: 0.4,
            },
        );
        show.observe(box);
        () => {
            show.disconnect();
        };
    }, []);

    useEffect(() => {
        const screen = AniContainer.create({
            triggerElement: '#AIDriven',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            asyncFromTo: [
                [`#AIDriven .AIDrivenVideo-container`, { opacity: 0 }, { opacity: 1 }, 0.2],
                [`#AIDriven .AIDrivenVideo-container`, { opacity: 1 }, { opacity: 1 }, 0.1],
            ],
            asyncTimeLine: [0.4, 0.7],
        });
        return () => {
            screen.destroy();
        };
    }, [isPC, isDesktop, isPad, isH5]);

    // 播放视频
    const boxRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!boxRef.current) return;
        const playingVideo = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = document.querySelector('#AIDriven video') as HTMLVideoElement;
                    if (entry.isIntersecting) {
                        video.play();
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );
        playingVideo.observe(boxRef.current);
        return () => {
            playingVideo.disconnect();
        };
    }, []);

    // 懒加载视频
    useEffect(() => {
        const loader = AniContainer.create({
            triggerElement: '#EcoAi',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setVideoLoaded(true);
            },
        });
        return () => {
            loader.destroy();
        };
    }, []);
    const video: {
        [key: string]: any;
    } = {
        us: [
            'https://websiteoss.ecoflow.com/upload/video/1735091245584/AIDriven.mp4', //pc
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png', //pc封面
            'https://websiteoss.ecoflow.com/upload/video/1735091245413/AIDriven-h5.mp4', //h5
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png', //h5封面
        ],
        ca: [
            'https://websiteoss.ecoflow.com/upload/video/1735091245584/AIDriven.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            'https://websiteoss.ecoflow.com/upload/video/1735091245413/AIDriven-h5.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],
        eu: [
            // 'https://websiteoss.ecoflow.com/upload/video/1735091245584/AIDriven.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1745742295752/AI_20250318_H.264_%E5%8E%8B%E7%BC%A9.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            // 'https://websiteoss.ecoflow.com/upload/video/1735091245413/AIDriven-h5.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1745824627201/KV-AI_M%E7%AB%AF_20250428_H.264.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/video/1745742295752/AI_20250318_H.264_%E5%8E%8B%E7%BC%A9.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            'https://websiteoss.ecoflow.com/upload/video/1745824627201/KV-AI_M%E7%AB%AF_20250428_H.264.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/video/1745894762025/pc-KV-AI_de_H.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            'https://websiteoss.ecoflow.com/upload/video/1745894782153/m-KV-AI_de_H.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/video/1745894769545/pc-KV-AI_fr_H.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            'https://websiteoss.ecoflow.com/upload/video/1745894775810/m-KV-AI_fr_H.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],

        //暂未提供素材
        it: [
            'https://websiteoss.ecoflow.com/upload/video/1745742295752/AI_20250318_H.264_%E5%8E%8B%E7%BC%A9.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            'https://websiteoss.ecoflow.com/upload/video/1745824627201/KV-AI_M%E7%AB%AF_20250428_H.264.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/video/1745742295752/AI_20250318_H.264_%E5%8E%8B%E7%BC%A9.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798134786/ai.png',
            'https://websiteoss.ecoflow.com/upload/video/1745824627201/KV-AI_M%E7%AB%AF_20250428_H.264.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735798135007/ai_M.png',
        ],
    };
    const tags = [
        {
            title: t('save1_title'),
            desc: t('save1_desc'),
        },
        {
            title: t('save2_title'),
            desc: t('save2_desc'),
        },
        {
            title: t('save3_title'),
            desc: t('save3_desc'),
        },
    ];
    let subTitle = t('subTitle');
    if (pageType === 'ultra') {
        subTitle = t('ultra_subTitle');
    } else if (pageType === 'ac') {
        subTitle = t('ac_subTitle');
    }
    return (
        <div className={`${styles.TheComp}`} id="AIDriven" ref={boxRef}>
            {euPages.includes(pageType) && (
                <div className="ai-normal">
                    <div className="ai-normal-title">{t('title')}</div>
                    <div className="ai-normal-desc">{subTitle}</div>
                    <div className="ai-normal-tags">
                        {tags.map((item, index) => {
                            return (
                                <div className="ai-normal-tag" key={index}>
                                    <div className="ai-normal-tag-title">{item.title}</div>
                                    <div className="ai-normal-tag-desc">{item.desc}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {pageType === 'na' && (
                <div className="ai-driven-info">
                    <div className="ai-driven-tag">
                        {icon}
                        <span>{t('ai')}</span>
                    </div>
                    <div className="ai-driven-title">{t('title')}</div>
                    <div className="ai-driven-desc">{t('subTitle')}</div>
                </div>
            )}

            <div className="AIDrivenVideo-container">
                {
                    // videoLoaded &&
                    isPC || isDesktop ? (
                        <EfVideo className="AIDrivenVideo" pc={video[locale][0]} poster={video[locale][1]} key="pc" preload="none" loop={false} />
                    ) : (
                        <EfVideo className="AIDrivenVideo" pc={video[locale][2]} poster={video[locale][3]} key="h5" preload="none" loop={true} />
                    )
                }
            </div>
        </div>
    );
}
